import {UntypedFormGroup} from '@angular/forms';

export class ImageSizeValidation {

  private static TWO_MB_IN_BYTES = 2097152;

  static ValidateSize(key: string) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const imageInput = group.controls[key];
      const image = imageInput.value;

      let imageFileSize;

      if (image) {
        // Split the base64 string in data and contentType
        const block = image.split(";");
        // Get the content type (ex.: image/png)
        const dataType = block[0].split(":")[1];
        // get the real base64 content of the file (ex.: iVBORw0KGg....)
        const realData = block[1].split(",")[1];

        imageFileSize = atob(realData).length;
      }

      if (image && imageFileSize > this.TWO_MB_IN_BYTES) {
        return {
          invalidImageSize: true
        };
      }
      return null;
    }
  }

}
